import React, { useState, useEffect } from 'react';
import {
  Table,
  TableHead,
  TableRow,
  TableHeaderCell,
  TableBody,
  TableCell,
  Flex,
  Button,
} from "@tremor/react";
import { ArrowUpRightIcon } from '@heroicons/react/24/outline';
import './UserListComponent.css';
import { Link } from "react-router-dom";
import { User } from '../../interfaces/AccessInterfaces';
import axios from 'axios';
import { useCookies } from 'react-cookie';

export default function UserListComponent() {
    const [cookies] = useCookies(['mazelog-user']);
    const token = cookies['mazelog-user']?.token_data?.access_token;
    const [users, setUsers] = useState<User[]>([]);
    const [requested, setRequested] = useState<boolean>(false);

    const orgId = cookies["mazelog-user"]?.organization_data?.id_org;
    const nameUser = cookies["mazelog-user"]?.organization_data?.name;
    const userProfile = cookies['mazelog-user']?.user_data?.user_profile;
    const isTransporter = userProfile === "TRANSPORTER" || userProfile === "TRANSPORTER_COLLECTER";

    const handleSubmit = async () => {
      const baseURL = process.env.REACT_APP_MAZELOG_AUTH_BASE_URL;
      const oauth = "Bearer " + token;

      try {
        if (isTransporter) {
          const urlCompany = `${baseURL}/users/company/${orgId}`;
          const urlAllocation = `${baseURL}/transporters/transporter_allocation/users?transporter=${nameUser}`;

          const [resCompany, resAllocation] = await Promise.all([
            axios.get(urlCompany, { headers: { accept: 'application/json', Authorization: oauth } }),
            axios.get(urlAllocation, { headers: { accept: 'application/json', Authorization: oauth } }),
          ]);

          const listA = resCompany.data?.data || [];
          const listB = resAllocation.data || [];

          setUsers([...listA, ...listB]);
          return;
        }

        // Non transporter
        const url = `${baseURL}/users`;
        const res = await axios.get(url, {
          headers: { accept: 'application/json', Authorization: oauth }
        });
        setUsers(res.data?.data || []);

      } catch (err) {
        console.log(err);
      }
    }

    useEffect(()=>{
        if (!requested){
          handleSubmit();
          setRequested(true);
        }
      },[requested])

  return (
    <div>
          <div className='mb-2'>
            <Flex justifyContent='end'>
                <Link to={`/users/create`}>
                  <Button className='DownloadBtn'>Criar usuário</Button>
                </Link>
            </Flex>
          </div>
        <Table>
            <TableHead>
                <TableRow>
                    <TableHeaderCell>ID usuário</TableHeaderCell>
                    <TableHeaderCell className="text-left">ID organização</TableHeaderCell>
                    <TableHeaderCell className="text-left">Nome de usuário</TableHeaderCell>
                    <TableHeaderCell className="text-left">Email</TableHeaderCell>
                    <TableHeaderCell className="text-left">Nome completo</TableHeaderCell>
                    <TableHeaderCell className="text-left">Telefone</TableHeaderCell>
                    <TableHeaderCell className="text-left">Perfil</TableHeaderCell>
                    <TableHeaderCell className="text-center">Permite alterar usuario do evento</TableHeaderCell>
                    <TableHeaderCell className="text-left">Ativo</TableHeaderCell>
                </TableRow>
            </TableHead>

            <TableBody>
                { users
                    .map((user) => (
                        <TableRow key={ user.id_user }>
                            <TableCell className="TableField">{ user.id_user }</TableCell>
                            <TableCell className="TableField">{ user.id_org }</TableCell>
                            <TableCell className="TableField">{ user.username }</TableCell>
                            <TableCell className="TableField">{ user.email }</TableCell>
                            <TableCell className="TableField">{ user.full_name }</TableCell>
                            <TableCell className="TableField">{ user.phone }</TableCell>
                            <TableCell className="TableField">{ user.user_profile }</TableCell>
                            <TableCell className="TableField">{ user.flag_alter_status_custom_user ? "Sim" : "Não" }</TableCell>
                            <TableCell className="TableField">{ user.active ? "Sim" : "Não" }</TableCell>    
                            <Link to={`/users/${user.id_user}?profile=${user.user_profile}`}>
                              <Button className='OpenOrderBtn' icon={ArrowUpRightIcon} />
                            </Link>
                        </TableRow>
                    )) }
            </TableBody>
        </Table>
    </div>
  );
}